import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import TaxEditForm from "./taxEditForm.component.jsx"
import {FormattedMessage} from 'react-intl'
import SideBar from '../../common/layout/sidebar.component.jsx'

class TaxNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        }
    }
    
    componentDidMount() {
        SideBar.activateMenu('account')
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12 ui-title-bar">
                        <div className="row">
                            <div className="col-12">
                                <h2>
                                    <FormattedMessage
                                        id="tax.form.new.title"
                                        defaultMessage="Create Tax"
                                    />
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <TaxEditForm />
            </div>
        );
    }
}

export default TaxNew


// WEBPACK FOOTER //
// ./src/settings/taxes/taxNew.component.jsx